var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddEmojiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smiley_18px",
    transform: "translate(-480 -5350)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 18,
    height: 18,
    transform: "translate(480 5350)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "smile_1_",
    "data-name": "smile (1)",
    transform: "translate(479 5349)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(2 2)",
    fill: "rgba(0,0,0,0)",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M8,14a5.4,5.4,0,0,0,4,2,5.4,5.4,0,0,0,4-2",
    transform: "translate(-2 -2.667)",
    fill: "rgba(0,0,0,0)",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 0.01,
    transform: "translate(7.599 7.6)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x2: 0.01,
    transform: "translate(12.399 7.6)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmojiIcon);
export default __webpack_public_path__ + "static/media/add-emoji-icon.fa0efa48cb1a6cd621da35ad57e6794a.svg";
export { ForwardRef as ReactComponent };